// ==========================
// Swiper
// ==========================
const swiper = new Swiper('.swiper', {
    autoplay: true,
    speed: 3000,
    loop: true,
    freeMode: true,
    centeredSlides: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    spaceBetween: 10,
    slidesPerView: 1.25,
    breakpoints: {
        768: {
            spaceBetween: 20,
            slidesPerView: 4,
        }
    }
});

// ==========================
// tab
// ==========================
const tabs = document.querySelectorAll('.tab')
function tabSwitch() {
    let tabsArray = Array.prototype.slice.call(tabs);
    let index = tabsArray.indexOf(this);
    const resetTab = function () {
        document.querySelector('.tab.active').classList.remove('active');
        document.querySelector('.tab[aria-selected=true]').removeAttribute('aria-selected');
        document.querySelectorAll('.tab').forEach((elm) => {
            elm.tabIndex = -1;
        });
        document.querySelector('.tab-panel.active').classList.remove('active');
    }
    const setTab = function (tab, tabpanel) {
        tab.classList.add('active');
        tab.tabIndex = 0;
        tab.setAttribute('aria-selected', true);
        tabpanel.classList.add('active');
    }
    if (event.type == 'keyup') {
        if (event.key === 'ArrowRight') {
            if (tabsArray[index + 1]) {
                tabsArray[index + 1].focus();
                resetTab();
                setTab(tabsArray[index + 1], document.querySelectorAll('.tab-panel')[index + 1]);
            } else {
                tabsArray[0].focus();
                resetTab();
                setTab(tabsArray[0], document.querySelectorAll('.tab-panel')[0]);
            };
        };
        if (event.key === 'ArrowLeft') {
            if (tabsArray[index - 1]) {
                tabsArray[index - 1].focus();
                resetTab();
                setTab(tabsArray[index - 1], document.querySelectorAll('.tab-panel')[index - 1])
            } else {
                let lastTab = tabsArray.pop();
                lastTab.focus();
                resetTab();
                setTab(lastTab, Array.prototype.slice.call(document.querySelectorAll('.tab-panel')).pop());
            };
        };
    }
    if (event.type == 'click') {
        resetTab();
        setTab(this, document.querySelectorAll('.tab-panel')[index]);
    }
};
tabs.forEach((tab) => {
    tab.addEventListener('click', tabSwitch);
    tab.addEventListener('keyup', tabSwitch);
});
